import { createNode } from '@glueapp/graph-types';

export const HyperbolicTangent = createNode({
    id: 'Hyperbolic Tangent',
    name: 'Hyperbolic Tangent',
    description: 'Gives the hyperbolic tangent of the value',
    aiDescription:
        'Computes the hyperbolic tangent of a number. Connect a value to the "Value" input port; the "Result" output port provides the hyperbolic tangent.',
    category: 'Math',
    color: '#5daa5b',
    integration: undefined,
    inPorts: {
        Value: {
            kind: 'number',
        },
    },
    outPorts: {
        Result: {
            kind: 'number',
        },
    },
    execute: function (input) {
        return { output: { Result: Math.tanh(input.inPorts.Value) } };
    },
});
